import { Button, Card, Input, Label } from "@repo/ui";
import { useEffect, useState } from "react";

export default function AdminSettings() {
  const [lineUrl, setLineUrl] = useState("");
  const [waUrl, setWaUrl] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await fetch("/api/admin/settings");
      const data = (await res.json()) as { status: string; data: Record<string, string> };
      setLineUrl(data.data.line_url || "");
      setWaUrl(data.data.whatsapp_url || "");
    })();
  }, []);

  async function save(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    await fetch("/api/admin/settings", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line_url: lineUrl, whatsapp_url: waUrl }),
    });
    setSaving(false);
  }

  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl">การตั้งค่า</h1>
      <Card className="p-4 bg-card/60 max-w-xl">
        <form onSubmit={save} className="grid gap-3">
          <div className="grid gap-1">
            <Label>ลิงก์ LINE</Label>
            <Input value={lineUrl} onChange={(e) => setLineUrl(e.target.value)} />
          </div>
          <div className="grid gap-1">
            <Label>ลิงก์ WhatsApp</Label>
            <Input value={waUrl} onChange={(e) => setWaUrl(e.target.value)} />
          </div>
          <Button type="submit" disabled={saving}>
            {saving ? "กำลังบันทึก..." : "บันทึก"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
